import React from "react";
import { withRouter } from "react-router-dom";
import {Helmet} from "react-helmet";

import "./feedback.css";
import Footer from "../../components/Footer/footer";
import "react-toastify/dist/ReactToastify.css";


class testimonials extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        name: "",
        phone: ""
    };
  }
  componentDidMount(){
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    
  }
  render() {
    return (
      <div style={{backgroundColor: "#EDF2F8", paddingTop:"3%"}}>
        <Helmet>
          <html lang="en" />  
          <meta charSet="utf-8" />
          <title>NIELIT Kohima - Digital Intervention of Handloom and Handicraft | Feedback</title>
          <meta name="description" content="The project 'Digital Intervention of Handicraft & Handloom' was commenced in the year 2021. Trainings for each of the sector are organised on monthly basis, which empowers the handicraft and handloom in the state of Nagaland as a pilot project initiated by the Ministry of Electronics and Information Technology, Govt. of India." />
          <link rel="canonical" href="https://nielitdihh.in/" />
        </Helmet>
        <p className="testimonial_header_txt">What Our Trainees Say</p>
        <div className="outerdiv">
            <div className="innerdiv">
                <div className="div1 eachdiv">
                    <div className="userdetails">
                    <div className="imgbox">
                        <img src={require("../../assets/Ngapkhow.png")} alt=""/>
                    </div>
                    <div className="detbox">
                        <p className="name">Ngapkhow<br/>Wangsa</p>
                    </div>
                    </div>
                    <div className="review">
                        <h4>
                            I am from Arunachal. I have a jacquard
                            handloom at home, but no one understands how to operate it. Therefore, I came
                            to NIELIT Dimapur for training to learn how to design and construct clothes.
                            Within one month, I learned how to do pirn winding, bobbin winding, wrapping,
                            harnessing, and drafting. I also learned how to design on the computer and then
                            transfer the pattern to the loom using a pen drive. After the training, I will return
                            to my hometown and educate and teach unemployed women, as well as women
                            interested in learning this digital intervention handloom to help women uplift
                            themselves and enhance their living standards through earnings. 
                        </h4>
                    </div>
                </div>
                <div className="div2 eachdiv">
                    <div className="userdetails">
                    <div className="imgbox">
                        <img src={require("../../assets/Minching.png")} alt=""/>
                    </div>
                    <div className="detbox">
                        <p className="name">Minching</p>
                    </div>
                    </div>
                    <div className="review">
                        <h4>
                            I've learned a lot about computers. I discovered that
                            we can build designs by creating a single motif, but we can also make many
                            copies by simply using copy-and-paste tools. In comparison to hand art, it
                            requires a significant amount of time and effort. So, knowing computer
                            knowledge is very beneficial to me. I've also learned how to use Microsoft
                            Word and Microsoft Paint. This has been an incredible experience, and I will
                            expand my skills and talent.
                        </h4>
                    </div>
                </div>
                <div className="div3 eachdiv">
                    <div className="userdetails">
                    <div className="imgbox">
                        <img src={require("../../assets/Chenchule.png")} alt=""/>
                    </div>
                    <div className="detbox">
                        <p className="name dark">Chenchule</p>
                    </div>
                    </div>
                    <div className="review dark">
                    <h4>
                        I am from Kithai village. I came to NIELIT
                        Dimapur for training to learn how to design and weaving. After two months of
                        training, I learned how to do pirn winding, bobbin winding, wrapping,
                        harnessing, and drafting. I also learned how to design on the computer and
                        then transfer the pattern to the loom micro-processing using a pen drive.
                        Following my training, I was appointed a master trainer at the Common
                        Facility Centre to educate other interested candidates. This opportunity has
                        allowed me to learn much about weaving and the benefits of digital
                        intervention in our lives, which can help me improve my living standards
                    </h4>
                    </div>
                </div>
                <div className="div4 eachdiv">
                    <div className="userdetails">
                    <div className="imgbox">
                        <img src={require("../../assets/Chollien.png")} alt=""/>
                    </div>
                    <div className="detbox">
                        <p className="name dark">Chollien</p>
                    </div>
                    </div>
                    <div className="review dark">
                        <h4>
                            I came to the NIELIT CFC to attend
                            CNC craving training and learn about CAD and CAM software like Aspire and
                            Coral Draw. I now own a farm thanks to a CNC machine. I am grateful to the
                            NIELIT Institute for providing this opportunity and time to enhance our creative
                            abilities.
                        </h4>
                    </div>
                </div>
                <div className="div5 eachdiv">
                    <div className="userdetails">
                    <div className="imgbox">
                        <img src={require("../../assets/Kenneth.png")} alt=""/>
                    </div>
                    <div className="detbox">
                        <p className="name">Kenneth</p>
                    </div>
                    </div>
                    <div className="review">
                    <h4>I came from Wokha to NIELIT Dimapur for handicraft training. We learned CAD design using Aspire and CorelDRAW, and created custom frames with a CNC machine. This training has been very beneficial, and with the skills I’ve gained, I’m confident I can work independently and continue to grow.</h4>
                    </div>
                </div>
            </div>
        </div>
        <div className="outerdiv" style={{marginTop: -85}}>
            <div className="innerdiv">
                <div className="div6 eachdiv">
                    <div className="userdetails">
                    <div className="imgbox">
                        <img src={require("../../assets/Lino.png")} alt=""/>
                    </div>
                    <div className="detbox">
                        <p className="name dark">Lino<br/>Chishi</p>
                    </div>
                    </div>
                    <div className="review dark">
                        <h4>
                            I'm from Zunheboto. I came to NIELIT Dimapur for training in design and weaving. Over two months, I learned pirn winding, bobbin winding, wrapping, harnessing, and drafting. I also gained skills in computer-aided design and transferring patterns to the loom using a pen drive. After the training, I was appointed as a master trainer at the Common Facility Centre to teach others. This opportunity has deepened my knowledge of weaving and shown me how digital tools can improve our lives and living standards.
                        </h4>
                    </div>
                </div>
                <div className="div8 eachdiv">
                    <div className="userdetails">
                    <div className="imgbox">
                        <img src={require("../../assets/Nyaiwang.png")} alt=""/>
                    </div>
                    <div className="detbox">
                        <p className="name">Nyaiwang</p>
                    </div>
                    </div>
                    <div className="review">
                        <h4>
                            During my one-week training at NIELIT, I learned how to create designs using Microsoft Paint, use colors effectively, and work with Microsoft Word and Excel. I also learned typing and how to arrange layout materials. Though the training was short, I gained valuable skills that will be very useful in the future. I'm grateful to NIELIT for offering this training free of cost and helping me realize the importance of these digital tools in our daily lives.
                        </h4>
                    </div>
                </div>
                <div className="div7 eachdiv">
                    <div className="userdetails">
                    <div className="imgbox">
                        <img src={require("../../assets/Ajan.png")} alt=""/>
                    </div>
                    <div className="detbox">
                        <p className="name">Ajan<br/>Ezung</p>
                    </div>
                    </div>
                    <div className="review">
                        <h4>
                            I am delighted to have participated in the one-month training at NIELIT’s handloom and handicraft facility. I learned digital design using software like Aspire and CorelDRAW, with excellent guidance from our trainer. After designing on the computer, we brought our designs to life using a CNC machine. Working with machines proved to be more convenient and cost-effective than doing everything by hand. Learning about CNC technology has made the process easier and more efficient. I’m very satisfied with the training experience.
                        </h4>
                    </div>
                </div>
                <div className="div4 eachdiv">
                    <div className="userdetails">
                    <div className="imgbox">
                        <img src={require("../../assets/Mannoi.png")} alt=""/>
                    </div>
                    <div className="detbox">
                        <p className="name dark">Mannoi</p>
                    </div>
                    </div>
                    <div className="review dark">
                        <h4>
                            We learned how to generate designs on the computer and how to weave. They taught us how to paint and use colour combinations while producing designs, and how to use the keyboard and mouse to create motif designs. They also showed us how to set up and use email for business. We are grateful to NIELIT for allowing us to discover things we never expected to know. Thank you for improving our talents and ingenuity.
                        </h4>
                    </div>
                </div>
                <div className="div9 eachdiv">
                    <div className="userdetails">
                    <div className="imgbox">
                        <img src={require("../../assets/Nyeman.png")} alt=""/>
                    </div>
                    <div className="detbox">
                        <p className="name">Nyeman</p>
                    </div>
                    </div>
                    <div className="review">
                    <h4>
                        Handloom and handicraft instructors from NIELIT
                        visited our community and educated us about computers. At the start, we
                        had little expertise about computers. They came and taught us how to design
                        motifs for our clothes and create designs using computer tools such as Corel
                        Draw and MS Paint. It was fun to learn that motifs may be made with a
                        computer. Our only desire is that the training session could have been
                        somewhat longer so that we could have learned more. Aside from that, we
                        are pleased and appreciative to the department for allowing us to learn
                        something new and exciting.
                    </h4>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
      </div>
    )
  }
}
export default withRouter(testimonials);